import type { ImgHTMLAttributes } from 'react';
import { useCallback, useState } from 'react';

const ImageComponent = ({ src, alt = 'Image', ...rest }: ImgHTMLAttributes<HTMLImageElement>) => {
	const [imageError, setImageError] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	const handleLoad = useCallback(() => {
		setIsLoading(false);
	}, []);

	const handleError = useCallback(() => {
		setImageError(true);
	}, []);

	const svgContent = `
    <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#F0F0F0" stroke="#ddd" stroke-width="2"/>
        <text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#999" font-family="Campton, sans-serif" font-size="13">
            No Image Available
        </text>
    </svg>
  `;

	const placeholderSvg = `data:image/svg+xml;base64,${btoa(svgContent)}`;

	return (
		<>
			{isLoading ? (
				<div
					className='button-spinner'
					data-testid='image-component-loading'
				/>
			) : null}

			<img
				src={imageError || !src ? placeholderSvg : src}
				style={{ display: isLoading ? 'none' : '' }}
				alt={alt}
				onError={handleError}
				onLoad={handleLoad}
				data-testid='image-component'
				{...rest}
			/>
		</>
	);
};

export default ImageComponent;
